const NotificationState = {
  emails: [],
  sms: [],
  ads: []
};

export default NotificationState;
